export default {
  mfa: {
    remoteLogin: {
      title: 'Remote Login',
      description: 'Please enter the remote login verification code',
      button: 'Verify',
      cancel: 'Cancel',
      close: 'Close',
      success: 'Verify Success',
      error: 'Verify Failed',
    },
  },
  form: {
    placeholder: {
      input: 'Please enter {label}',
    },
  },
}
